import GroupCardV2 from '../BracketForm/GroupCardV2'
import TeamTile from '../BracketForm/TeamTile'
import { Card, Empty } from 'antd'
import React from 'react'

const formatPlacement = (position) => {
  if (position === 1) return '1st'
  if (position === 2) return '2nd'
  if (position === 3) return '3rd'
  return '4th'
}

const buildTeamOption = (teamId, rankings) => {
  const ranking = rankings[String(teamId)]
  return ranking
    ? { ...ranking, value: teamId }
    : { value: teamId, name: String(teamId), rank: null, flag: '/flags/Mystery.png' }
}

export default function BracketV2PhaseOneView({ picks, rankings, scorecard }) {
  const groupRankings = picks._group_rankings || {}
  const advancingThirdPlaceTeams = picks._advancing_third_place_teams || []
  const groups = Object.entries(scorecard?.groups || {})

  const thirdPlaceTeams = Object.entries(groupRankings)
    .map(([groupName, placements]) => {
      const teamId = placements[2]
      if (!teamId) return null

      return {
        ...buildTeamOption(teamId, rankings),
        groupName,
      }
    })
    .filter(Boolean)
    .sort((a, b) => a.name.localeCompare(b.name))

  return (
    <div className="bracket-group-form bracket-v2-phase-one-view">
      {groups.length
        ? <div className="groups-container">
            {groups.map(([name, group]) => {
              const teams = [...group]
                .sort((a, b) => String(a).localeCompare(String(b)))
                .map(country => buildTeamOption(country, rankings))

              return (
                <GroupCardV2
                  key={name}
                  formatPlacement={formatPlacement}
                  group={teams}
                  name={name}
                  placements={groupRankings[name] ?? []}
                  setPlacements={() => null}
                />
              )
            })}
          </div>
        : <Empty description="No group stage picks available." />
      }

      <div className="groups-header third-place-header">
        <h2 className="wc-font">Advancing Third Place Teams</h2>
      </div>

      <div className="groups-container">
        <Card className="group-card third-place-card bracket-v2-third-place-readonly">
          {thirdPlaceTeams.length
            ? thirdPlaceTeams.map(team => (
                <TeamTile
                  key={`${team.groupName}-${team.value}`}
                  selected={advancingThirdPlaceTeams.some(value => String(value) === String(team.value))}
                  team={team}
                />
              ))
            : <Empty description="No third place selections available." />
          }
        </Card>
      </div>
    </div>
  )
}
